import { Card, Flex, NumberInput, Text, Title } from '@tremor/react'
import type { InputsState, Labels } from '../types'

interface Props {
    inputs: InputsState
    setInputs: (updates: Partial<InputsState>) => void
    labels: Labels
}

export default function ComputeStep({ inputs, setInputs, labels }: Props) {
    return (
        <Card className="bg-teal-800 ring-teal-900">
            <Title className="text-lg mb-2 text-white">
                Compute ({labels.vmName})
            </Title>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Instances count
                </Text>
                <NumberInput
                    value={inputs.ec2Instances}
                    onValueChange={(v) => setInputs({ ec2Instances: v })}
                    min={0}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Average CPU utilization (%)
                </Text>
                <NumberInput
                    value={inputs.ec2AvgUtil}
                    onValueChange={(v) => setInputs({ ec2AvgUtil: v })}
                    min={0}
                    max={100}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    {labels.savingsLabel} coverage (%)
                </Text>
                <NumberInput
                    value={inputs.savingsPlanCoverage}
                    onValueChange={(v) => setInputs({ savingsPlanCoverage: v })}
                    min={0}
                    max={100}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
        </Card>
    )
}
